import React,{ useCallback, useEffect, useState, useMemo, useRef } from 'react';
// import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import "./index.scss";

import DropDown from '../../../ui/DropDown';
import SideModal from "../../../ui/SideModal";
import SkeletonLoader from "../../../ui/SkeletonLoader";

import DownloadReport from "../Reports/DownloadReport";

import { downloadReportIcon } from "../../../../utils/icons";
import { getloggedInUserType } from "../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { getCustomersList, getOrganizationList, getDomainList, resetDomainListResponse, getPorfolioCustomersList, portfolioCustomerSelectedValue, getScanHistory, resetScanHistoryList } from "../../../../store/actions/scanInfoAction";
import { getCustomerDetails, resetCustomerDetailResponse } from "../../../../store/actions/customerAction";
import { getOrganizationDetails, resetOrganizationDetail } from "../../../../store/actions/organizationActions";
import { getDomainDetails, resetDomainDetails } from "../../../../store/actions/domainAction";

const Header = () => {

    const domainListResponse = useSelector((state) => state.scanInfo?.domainList);
    const organizationListResponse = useSelector((state) => state.scanInfo?.organizationList);
    const customersListResponse = useSelector((state) => state.scanInfo?.customerList);
    const scanHistoryResponse = useSelector((state) => state.scanInfo?.scanHistoryList);

    const customerDetailResponse = useSelector((state) => state.customer?.customerDetailResponse);
    const organizationDetailResponse = useSelector((state) => state.organization?.organizationDetail);
    const domainDetailResponse = useSelector((state) => state.domain?.domainDetails);

    const portfolioCustomersListResponse = useSelector((state) => state?.scanInfo?.portfolioCustomersList);

    const dispatch = useDispatch();

    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;
    
    const queryParams = new URLSearchParams(location.search);

    function useDebounce(value, delay = 500) {
        const [debounced, setDebounced] = useState(value);

        useEffect(() => {
            const handler = setTimeout(() => setDebounced(value), delay);
            return () => clearTimeout(handler);
        }, [value, delay]);

        return debounced;
    }

    const routeContext = useMemo(() => {
        const segments = pathname.split("/");
            return {
                isThirdPartyPage: segments[2] === "third-party",
                isPortfolioPage: segments[2] === "portfolio",
                isExposurePage: segments[2] === "exposure",
            };
    }, [pathname]);

    const customerId = queryParams.get('customer');
    const organizationId = queryParams.get('organization');
    const domainId = queryParams.get('domain');
    const scanId = queryParams.get('scanId');

    const prevCustomerIdRef = useRef(null);
    const prevOrganizationIdRef = useRef(null);
    const previousLocationRef = useRef(null);
    const thirdPartyFetchedRef = useRef(false);

    const [previousUrl, setPreviousUrl] = useState(null);

    const [searchParams, setSearchParams] = useSearchParams();

    const [pageHeading, setPageHeading] = useState("");

    const [selectedDate, setSelectedDate] = useState(null);

    const [customerLoading, setCustomerLoading] = useState(false)
    const [customersList, setCustomersList] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [customerSearch, setCustomerSearch] = useState("");
    const [customerSearchLoading, setCustomerSearchLoading] = useState(false);
    const [customerListCurrentPage, setCustomerListCurrentPage] = useState(1);
    const [customerListPageLoading, setCustomerListPageLoading] = useState(false);
    const [customerListTotalPage, setCustomerListTotalPage] = useState(0);

    const [organizationLoading, setOrganizationLoading] = useState(false)
    const [organizationList, setOrganizationList] = useState([]);
    const [selectedOrganization, setSelectedOrganization] = useState("");
    const [organizationSearch, setOrganizationSearch] = useState("");
    const [organizationSearchLoading, setOrganizationSearchLoading] = useState(false);
    const [organizationListCurrentPage, setOrganizationListCurrentPage] = useState(1);
    const [organizationListPageLoading, setOrganizationListPageLoading] = useState(false);
    const [organizationListTotalPage, setOrganizationListTotalPage] = useState(0);

    const [domainLoading, setDomainLoading] = useState(false)
    const [domainList, setDomainList] = useState([]);
    const [selectedDomain, setSelectedDomain] = useState("");
    const [domainSearch, setDomainSearch] = useState("");
    const [domainSearchLoading, setDomainSearchLoading] = useState(false);
    const [domainListCurrentPage, setDomainListCurrentPage] = useState(1);
    const [domainListPageLoading, setDomainListPageLoading] = useState(false);
    const [domainListTotalPage, setDomainListTotalPage] = useState(0);

    const [availableDates, setAvailabelDates] = useState([]);
    const [scanHistoryList, setScanHistoryList] = useState(null);
    const [scanHistoryCurrentPage, setScanHistoryCurrentPage] = useState(1);
    const [scanHistoryAllDates, setScanHistoryAllDates] = useState([]);
    const [allScanHistoryResults, setAllScanHistoryResults] = useState([]);
    const [scanType, setScanType] = useState(null);

    const [hideSwitchShow, setHideSwitchShow] = useState(false);

    //portfolio customers list
    const [portfolioCustomerLoading, setPortfolioCustomerLoading] = useState(false);
    const [portfolioCustomersList, setPortfolioCustomersList] = useState([]);
    const [portfolioSelectedCustomer, setPortfolioSelectedCustomer] = useState("");
    const [portfolioCustomerSearchValue, setPortfolioCustomerSearchValue] = useState("");
    const [portfolioCustomerSearchLoading, setPortfolioCustomerSearchLoading] = useState(false);
    const [portfolioCustomerListCurrentPage, setPortfolioCustomerListCurrentPage] = useState(1);
    const [portfolioCustomerListPageLoading, setPortfolioCustomerListPageLoading] = useState(false);
    const [portfolioCustomerListTotalPage, setPortfolioCustomerListTotalPage] = useState(0);

    const [showAddOrgSidePanel, setShowAddOrgSidePanel] = useState(false);
    
    const [scanHistoryLoading, setScanHistoryLoading] = useState(false);

    const debouncedCustomerSearch = useDebounce(customerSearch, 500);
    const debouncedOrganizationSearch = useDebounce(organizationSearch, 500);
    const debouncedDomainSearch = useDebounce(domainSearch, 500);
    const debouncedPortfolioCustomerSearch = useDebounce(portfolioCustomerSearchValue, 500);

    const allValue = useMemo(() => ({
        id: "all",
        name: "All",
        value: "all",
        logo: null,
        label: "All",
        domain: "All"
    }), []);

    const domainAllValue = useMemo(() => ({
        id: "all",
        name: "All",
        value: "all",
        logo: null,
        label: "All",
        domain: "All",
        lastScanDetails : {
            created_at: null,
            scan_id: null
        }
    }), []);

    const closeAddOrgSidePanel = () => {
        setShowAddOrgSidePanel(false)
    }

    const isSameDay = (date1, date2) => {
        if (!date1 || !date2) return false;

        const d1 = new Date(date1);
        const d2 = new Date(date2);

        d1.setHours(0, 0, 0, 0);
        d2.setHours(0, 0, 0, 0);

        return (
            d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate()
        );
    };

    const isAvailableDate = (date) => {
        if (!date) return false;
        return availableDates.some((availableDate) => isSameDay(availableDate, date));
    };

    // Highlight available dates
    const highlightAvailableDates = (date) => {
        return isAvailableDate(date) ? "highlighted-date" : undefined;
    };    

    const CalenderIcon = () => {
        return  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.66663 1.6665V4.1665" stroke="#00308B" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13.3334 1.6665V4.1665" stroke="#00308B" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2.91663 7.57471H17.0833" stroke="#00308B" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M17.5 7.08317V14.1665C17.5 16.6665 16.25 18.3332 13.3333 18.3332H6.66667C3.75 18.3332 2.5 16.6665 2.5 14.1665V7.08317C2.5 4.58317 3.75 2.9165 6.66667 2.9165H13.3333C16.25 2.9165 17.5 4.58317 17.5 7.08317Z" stroke="#00308B" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13.079 11.4167H13.0864" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13.079 13.9167H13.0864" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.9962 11.4167H10.0037" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.9962 13.9167H10.0037" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M6.91197 11.4167H6.91945" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M6.91197 13.9167H6.91945" stroke="#00308B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
    }

    const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
        <input
            ref={ref}
            value={value}
            onClick={onClick}
            readOnly // Make the input non-editable
            className={`${domainId.toLowerCase() === "all" ? "form-control disabled" : "form-control"}`}
            placeholder="Select a date"
        />
    ));

    const changeScannedDate = (date) => {
        setSelectedDate(date)
        const normalizedSelected = new Date(date);
        normalizedSelected.setHours(0,0,0,0);

        const index = availableDates.findIndex(av => isSameDay(av, normalizedSelected));

        setScanType(scanHistoryList?.results[index]?.scan_type)
        searchParams.set('scanId', scanHistoryList?.results[index].scan_id);
        setSearchParams(searchParams);
    }

    const handleSelectCustomer = (value) => {
        setSelectedCustomer(value.value)
        setOrganizationList([])
        setDomainList([])
        searchParams.set('customer', value.value);
        searchParams.set('organization', "all");  
        setSearchParams(searchParams);
    }

    const handleSelectOrganization = (value) => {
        searchParams.set('organization', value.value);        
        setSearchParams(searchParams);
        if(value.value.toLowerCase() !== "all") {
            setSelectedDomain("all")
            searchParams.set('domain', "all");
            setScanType(null)
            searchParams.set('scanId', "null");
            setSearchParams(searchParams);
        }
        setDomainList([])
        // setSelectedOrganization(value.value);
    }

    const handleSelectDomain = (value) => {
        setSelectedDate(null); // Reset selected date
        setAvailabelDates([]); // Reset available dates
        setScanType(null); // Reset scan type if needed

        setSelectedDomain(value.value);
        setScanHistoryCurrentPage(1);

        const newParams = new URLSearchParams(searchParams.toString());
        newParams.set('domain', value.label.toLowerCase());

        if (value.value.toLowerCase() === "all") {
            newParams.set('scanId', "null");
        }

        setSearchParams(newParams);

        // searchParams.set('domain', value.label.toLowerCase());
        // if(value.value.toLowerCase() === "all") {
        //     searchParams.set('scanId', "null");
        // }
        // // searchParams.set('scanId', value?.lastScanDetails?.scan_id);
        // setSelectedDate(value?.lastScanDetails?.created_at);
        // setSearchParams(searchParams);
        // setScanHistoryCurrentPage(1);
        // setAvailabelDates([]);
    }

    const fetchCustomerDetails = useCallback(()=>{
        let obj = {
            customer_id: customerId
        }
        dispatch(getCustomerDetails(obj))
    },[customerId, dispatch])

    const fetchOrganizationDetails = useCallback(()=>{
        let obj = {
            organization_id: organizationId,
            ...(routeContext.isThirdPartyPage ? { organization_type: "third_party" } : "")
        }
        dispatch(getOrganizationDetails(obj))
    },[organizationId, dispatch, routeContext.isThirdPartyPage])

    const fetchDomainDetails = useCallback(()=>{
        if(domainId !== undefined && domainId !== "all") {
            // console.log("domainId", domainId)
            let obj = {
                domain: domainId,
                ...(routeContext.isThirdPartyPage ? { domain_type: "third_party" } : "")
            }
            dispatch(getDomainDetails(obj))
        }           
        
    },[domainId, dispatch, routeContext.isThirdPartyPage])

    const fetchScanHistory = useCallback(()=>{
        setScanHistoryLoading(true)
        const baseUrl = `&domain=${domainId}`;
        const params = routeContext.isThirdPartyPage ? `&scan_type=passive` : "";
        const pagination = `&page=${scanHistoryCurrentPage}&page_size=50`;
        let url = `${baseUrl}${params}${pagination}`;
        dispatch(getScanHistory(url));
    },[dispatch, domainId, scanHistoryCurrentPage, routeContext.isThirdPartyPage])

    useEffect(()=>{
        if(domainId.toLowerCase() !== "all") {
            fetchScanHistory()
        }
    },[domainId, fetchScanHistory])

    const fetchDomains = useCallback(()=>{        
        dispatch(resetDomainListResponse())
        let baseUrl = `&page=1&page_size=10`;
        let domainType = routeContext.isThirdPartyPage ? `&domain_type=third_party` : "";
        let url = `${baseUrl}${domainType}`
        if(routeContext.isThirdPartyPage) {            
            setDomainList([])
            dispatch(getDomainList(url))
        } else {
            dispatch(getDomainList(url))
        }
        if(customerId === "all" && (customerId !== prevCustomerIdRef.current || organizationId !== prevOrganizationIdRef.current)) {            
            setDomainLoading(true)
            dispatch(getDomainList(url))
            prevCustomerIdRef.current = customerId;
            prevOrganizationIdRef.current = organizationId;
        }

        if(customerId !== "all" && organizationId === "all") {            
            url = url + `&customer_id=${customerId}`
            setDomainLoading(true)
            dispatch(getDomainList(url))
        }

        if(organizationId !== "all" && customerId === "all") {            
            url = url + `&organization_id=${organizationId}`
            setDomainLoading(true)
            dispatch(getDomainList(url))
        }

        if(organizationId !== "all" && customerId !== "all") {            
            url = url + `&customer_id=${customerId}&organization_id=${organizationId}`
            setDomainLoading(true)
            dispatch(getDomainList(url))
        }

    },[customerId, organizationId, dispatch, routeContext.isThirdPartyPage])

    const fetchOrganizations = useCallback(()=>{
        if(routeContext.isThirdPartyPage && !thirdPartyFetchedRef.current) {
            setOrganizationList([])
            // const from = previousUrl.current
            if(previousUrl?.split("/")[2] === "exposure") {
                setSelectedCustomer("all")
                searchParams.set('organization', "all");
                setSearchParams(searchParams);
            }
            let baseUrl = customerId.toLocaleLowerCase !== "all" ? `&page=1&page_size=5&customer_id=${customerId}`: `&page=1&page_size=5`;
            let organizationType = routeContext.isThirdPartyPage ? `&organization_type=third_party` : "&organization_type=internal&organization_type=portfolio";
            let url = `${baseUrl}${organizationType}`
            dispatch(getOrganizationList(url));
            thirdPartyFetchedRef.current = true;
        }
        if (customerId !== prevCustomerIdRef.current) {
            setOrganizationLoading(true)
            let baseUrl = customerId.toLocaleLowerCase !== "all" ? `&page=1&page_size=5&customer_id=${customerId}`: `&page=1&page_size=5`;
            let organizationType = routeContext.isThirdPartyPage ? `&organization_type=third_party` : "&organization_type=internal&organization_type=portfolio";
            let url = `${baseUrl}${organizationType}`
            dispatch(getOrganizationList(url));
            prevCustomerIdRef.current = customerId; // Update the stored value
        }

        if(getloggedInUserType() === "internal" && customerId === "all") {
            // console.log("organization-test1")
            setSelectedOrganization("all")
            searchParams.set('organization', "all");
            setSearchParams(searchParams);
        }
    },[customerId, dispatch, searchParams, routeContext.isThirdPartyPage, setSearchParams, previousUrl])

    const fetchCustomersList = useCallback(()=>{
        setCustomerLoading(true)      
        let url = `&page=1&page_size=10`
        dispatch(getCustomersList(url))
    },[dispatch])

    useEffect(() => {
        setPreviousUrl(previousLocationRef.current);
        previousLocationRef.current = location.pathname;
    }, [location]);

    useEffect(()=>{
        const baseUrl = customerId.toLowerCase !== "all" ? `&page=${organizationListCurrentPage}&page_size=10&customer_id=${customerId}`: `&page=${organizationListCurrentPage}&page_size=10`;
        const queryParams = debouncedOrganizationSearch ? `&query=${debouncedOrganizationSearch}` : "";
        let organizationType = routeContext.isThirdPartyPage ? `&organization_type=third_party` : "&organization_type=internal&organization_type=portfolio";
        const url = `${baseUrl}${queryParams}${organizationType}`;
        dispatch(getOrganizationList(url));
    },[debouncedOrganizationSearch, customerId, dispatch, organizationListCurrentPage, routeContext.isThirdPartyPage]);

    useEffect(() => {
        // Reset the flag if user leaves third-party section
        if (!routeContext.isThirdPartyPage) {
            thirdPartyFetchedRef.current = false;
        }
    }, [routeContext.isThirdPartyPage, fetchOrganizations]);

    useEffect(()=>{
        const baseUrl = `&page=${domainListCurrentPage}&page_size=10`
        const queryParams = debouncedDomainSearch ? `&query=${debouncedDomainSearch}` : "";
        let domainType = routeContext.isThirdPartyPage ? `&domain_type=third_party` : "";
        let url = `${baseUrl}${queryParams}${domainType}`
        if(customerId === "all" && organizationId === "all") {
            dispatch(getDomainList(url));
        }

        if(customerId !== "all" && organizationId === "all") {
            url = url + `&customer_id=${customerId}`
            dispatch(getDomainList(url));
        }

        if(customerId === "all" && organizationId !== "all") {
            url = url + `&organization_id=${organizationId}`
            dispatch(getDomainList(url));
        }
        
        if(customerId !== "all" && organizationId !== "all") {
            url = url + `&customer_id=${customerId}&organization_id=${organizationId}`
            dispatch(getDomainList(url));
        }
    },[customerId, organizationId, debouncedDomainSearch, dispatch, domainListCurrentPage, routeContext.isThirdPartyPage, fetchDomains])

    useEffect(()=>{        
        const baseUrl = `&page=${customerListCurrentPage}&page_size=10`;
        const queryParams = debouncedCustomerSearch ? `&query=${debouncedCustomerSearch}` : "";
        const url = `${baseUrl}${queryParams}`
        dispatch(getCustomersList(url))
    },[dispatch, debouncedCustomerSearch, customerListCurrentPage])
    
    useEffect(()=>{
        if(getloggedInUserType() === "internal") {
            fetchCustomersList(); 
        }           
    },[fetchCustomersList])

    useEffect(()=>{
        if(getloggedInUserType() !== "internal") {
            fetchOrganizations();
        }             
    },[fetchOrganizations])

    useEffect(() => {
        if(customerId !== prevCustomerIdRef.current) {
            setOrganizationList([]);            // clear existing options
            setOrganizationListCurrentPage(1);  // reset pagination
            setOrganizationListTotalPage(0);
            setSelectedOrganization("");        // clear selection (optional)

            // If you also want to clear domains when customer changes, uncomment:
            // setDomainList([]);
            // setDomainListCurrentPage(1);
            // setDomainListTotalPage(0);
            // setSelectedDomain("");
            prevCustomerIdRef.current = customerId;
        }
        
    }, [selectedCustomer, customerId]);

    useEffect(()=>{
        if(customersListResponse !== null) {
            setCustomerLoading(false)
            setCustomerSearchLoading(false)
            setCustomerListPageLoading(false)
            const list = Array.isArray(customersListResponse?.results)
            ? customersListResponse?.results.map((data) => ({
                  id: data?.customer_id,
                  name: data?.name,
                  value: data?.customer_id,
                  logo: data?.logo,
                  label: data?.name,
              }))
            : [];

            const isThirdPartyDashboard = pathname.split("/")[2] === "third-party" && pathname.split("/")[3] === "dashboard-overview";

            const finalList = isThirdPartyDashboard ? [...list] : [allValue, ...list];

            // let finalList = [allValue, ...list]
            setCustomersList((prevList) => {
                const filteredPrevList = isThirdPartyDashboard ? prevList.filter(item => item.id !== allValue.id) : [allValue, ...prevList];

                const uniqueList = [...filteredPrevList, ...finalList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setCustomerListTotalPage(customersListResponse?.meta?.total_pages)
            if(isThirdPartyDashboard && customerId === "all" && getloggedInUserType() === "internal") {
                setSelectedCustomer(finalList[0].value)
                searchParams.set('customer', finalList[0].value);
                setSearchParams(searchParams);
            } else {
                const selectedValue = finalList.find(
                    (option) => option.value === customerId
                );
                if(selectedValue) {
                    setSelectedCustomer(selectedValue.value)
                } else {
                    fetchCustomerDetails()
                }
            }
                       
            fetchOrganizations();
        }
    },[customersListResponse, allValue, customerId, pathname, searchParams, setSearchParams, fetchOrganizations, fetchCustomerDetails])

    useEffect(()=>{        
        if(organizationListResponse !== null) {
            setOrganizationLoading(false)
            setOrganizationSearchLoading(false)
            setOrganizationListPageLoading(false)
            const list = Array.isArray(organizationListResponse?.results)
                ? organizationListResponse?.results.map((data) => ({
                    id: data?.organization_id,
                    name: data?.name,
                    value: data?.organization_id,
                    logo: data?.logo,
                    label: data?.name,
                }))
                : [];
            let finalList = [allValue, ...list];
            if (organizationListCurrentPage === 1) {
                setOrganizationList(finalList);
            } else {
                setOrganizationList((prevList) => {
                    const uniqueList = [...prevList, ...finalList].reduce((acc, item) => {
                        if (!acc.some(existingItem => existingItem.id === item.id)) {
                            acc.push(item);
                        }
                        return acc;
                    }, []);
                    return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
                });
            }
            setOrganizationListTotalPage(organizationListResponse?.meta?.total_pages)
            if(customerId !== "all" || getloggedInUserType() === "customer") {
                const selectedValue = finalList?.find(
                    (option) => option?.value === organizationId
                );
                if(selectedValue) {
                    // console.log("organization-test2")
                    setSelectedOrganization(selectedValue.value)
                } else {
                    // console.log("organization-test3")
                    fetchOrganizationDetails();
                }
            }
            // fetchDomains()
        }
    },[customerId, organizationId, organizationListResponse, organizationListCurrentPage, searchParams, setSearchParams, allValue, fetchDomains, fetchOrganizationDetails])

    useEffect(()=>{
        if (scanHistoryList?.results.length > 0) {
            let index = scanHistoryList?.results.findIndex((data) => data.scan_id === scanId)
            setSelectedDate(scanHistoryList?.results[index]?.created_at)
        } else {
            setSelectedDate("")
        }
    },[scanId, scanHistoryList])

    useEffect(() => {
        if (domainListResponse !== null) {            
            setDomainLoading(false)
            setDomainSearchLoading(false)
            setDomainListPageLoading(false)
            const list = Array.isArray(domainListResponse?.results)
                ? domainListResponse?.results.map((data) => ({
                    id: data?.domain_id,
                    name: data?.domain,
                    value: data?.domain,
                    logo: data?.logo,
                    label: data?.domain,
                    domain: data?.domain,
                    lastScanDetails: data?.last_scan_detail
                }))
            : [];

            const isThirdPartyDashboard = pathname.split("/")[2] === "third-party" && pathname.split("/")[3] === "dashboard-overview";
            if (isThirdPartyDashboard) {
                // setDomainList([])
                if(list?.length > 0) {
                    setDomainList([...list])
                    setSelectedDomain(list[0]?.value)
                    searchParams.set('domain', list[0]?.label);
                    return
                } else {
                    setDomainList([domainAllValue])
                    setSelectedDomain("all")
                    searchParams.set('domain', "all");
                    return
                }                
            }

            if(domainSearch !== "") {             
                setDomainList((prevList) => {
                    const uniqueList = [...prevList, ...list].reduce((acc, item) => {
                        if (!acc.some(existingItem => existingItem.id === item.id)) {
                            acc.push(item);
                        }
                        return acc;
                    }, []);
                    return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
                });
                setDomainListTotalPage(domainListResponse?.meta?.total_pages)
            } else {
                // console.log("test - 1")                
                const finalList = organizationId === "all" && list?.length !== 0 ? list : [domainAllValue, ...list];
                setDomainList((prevList) => {
                    const uniqueList = [...prevList, ...finalList].reduce((acc, item) => {
                        if (!acc.some(existingItem => existingItem.id === item.id)) {
                            acc.push(item);
                        }
                        return acc;
                    }, []);
                    return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
                });
                setDomainListTotalPage(domainListResponse?.meta?.total_pages)

                if(customerId === "all" && organizationId === "all") {
                    // console.log("test - 2")
                    const selectedValue = finalList?.find(
                        (option) => option.label.toLowerCase() === domainId.toLowerCase()
                    );
                    if(selectedValue) {
                        // console.log("test - 3")
                        setSelectedDomain(selectedValue?.value)
                        searchParams.set('domain', selectedValue?.label); 
                        if(scanId !== "null") {
                            // console.log("test - 4")
                            if(scanId === selectedValue?.lastScanDetails?.scan_id) {
                                // console.log("test - 5")
                                // searchParams.set('scanId', selectedValue?.lastScanDetails?.scan_id);
                                // setSelectedDate(selectedValue?.lastScanDetails?.created_at);
                            } else {
                                // console.log("test - 6")
                                searchParams.set('scanId', scanId);
                            }
                        } else {
                            // console.log("test - 7")
                            // searchParams.set('scanId', selectedValue?.lastScanDetails?.scan_id);
                            // setSelectedDate(selectedValue?.lastScanDetails?.created_at);
                        }                             
                        setSearchParams(searchParams);
                    } else {
                        // console.log("test - 8")
                        if(domainId.toLowerCase() === "all") {
                            // console.log("test - 9")
                            setSelectedDomain(finalList[0]?.value)
                            searchParams.set('domain', finalList[0]?.label);
                            if(scanId !== "null") {
                                // console.log("test - 10")
                                if(scanId === finalList[0]?.lastScanDetails?.scan_id) {
                                    // console.log("test - 11")
                                    // searchParams.set('scanId', finalList[0]?.lastScanDetails?.scan_id);
                                    // setSelectedDate(finalList[0]?.lastScanDetails?.created_at)
                                } else {
                                    // console.log("test - 12")
                                    searchParams.set('scanId', scanId);
                                }
                            } else {
                                // console.log("test - 13")
                                // searchParams.set('scanId', finalList[0]?.lastScanDetails?.scan_id);
                                // setSelectedDate(finalList[0]?.lastScanDetails?.created_at)
                            }                               
                            setSearchParams(searchParams);
                        } else {
                            // console.log("test - 14")
                            fetchDomainDetails()
                        }                        
                    }
                } else {
                    // console.log("test - 15")
                    if(organizationId === "all" && finalList?.length === 0) {
                        // console.log("test - 16")
                        setDomainList([domainAllValue])              
                        setSelectedDomain(domainAllValue?.value);
                        searchParams.set('domain', domainAllValue?.label);
                        searchParams.set('scanId', "null");    
                        setSearchParams(searchParams);
                        setScanType(null);
                    }
    
                    if(organizationId === "all" && finalList?.length > 0) {
                        // console.log("test - 17")
                        const selectedValue = finalList?.find(
                            (option) => option.label.toLowerCase() === domainId.toLowerCase()
                        );
                        if(selectedValue) {
                            // console.log("test - 18")
                            setSelectedDomain(selectedValue?.value);
                            searchParams.set('domain', selectedValue?.label);
                            if(scanId !== "null") {
                                // console.log("test - 19")
                                searchParams.set('scanId', selectedValue?.lastScanDetails?.scan_id);
                                setSelectedDate(selectedValue?.lastScanDetails?.created_at)
                            } else {
                                // console.log("test - 20")
                                // searchParams.set('scanId', selectedValue?.lastScanDetails?.scan_id);                            
                                // setSelectedDate(selectedValue?.lastScanDetails?.created_at) 
                            }
                            
                            setSearchParams(searchParams);
                        } else{
                            // console.log("test - 21")
                            setSelectedDomain(finalList[0]?.value);
                            searchParams.set('domain', finalList[0]?.label);
                            if(scanId !== "null") {
                                // console.log("test - 22")
                                searchParams.set('scanId', finalList[0]?.lastScanDetails?.scan_id);
                                setSelectedDate(finalList[0]?.lastScanDetails?.created_at)
                            } else {
                                // console.log("test - 23")
                                // searchParams.set('scanId', finalList[0]?.lastScanDetails?.scan_id);
                                // setSelectedDate(finalList[0]?.lastScanDetails?.created_at)
                            }                           
                            setSearchParams(searchParams);
                        }
                        
                    }            
    
                    if((customerId !== "all" && organizationId !== "all") || getloggedInUserType() === "customer" ) {  
                        // console.log("test - 24")           
                        const selectedValue = finalList?.find(
                            (option) => option.label.toLowerCase() === domainId.toLowerCase()
                        );
                        
                        if(selectedValue) {
                            // console.log("test - 25")
                            setSelectedDomain(selectedValue?.value)
                            searchParams.set('domain', selectedValue?.label);
                            if(scanId !== "null") {
                                // console.log("test - 26")
                                if(scanId === selectedValue?.lastScanDetails?.scan_id) {
                                    // console.log("test - 27")
                                    // searchParams.set('scanId', selectedValue?.lastScanDetails?.scan_id);                            
                                    // setSelectedDate(selectedValue?.lastScanDetails?.created_at)
                                } else {
                                    // console.log("test - 28")
                                    // searchParams.set('scanId', scanId);
                                }
                                // console.log("test - 29")
                            } else {
                                // console.log("test - 30")
                                // searchParams.set('scanId', selectedValue?.lastScanDetails?.scan_id);                            
                                // setSelectedDate(selectedValue?.lastScanDetails?.created_at)
                            }                           
                            setSearchParams(searchParams);
                        } else {
                            fetchDomainDetails()
                        }               
                    }
                    
                }
                
            }
            dispatch(resetDomainListResponse())           
        } else {
            // console.log("Waiting for domainListResponse...");
            const timeout = setTimeout(() => {
                // setOverlayLoader(false); // Fallback to ensure the loader stops after a max time.
                // console.log("stoping loader from fallback");
            }, 3000); // Adjust the timeout as needed (e.g., 3 seconds).
        
            return () => clearTimeout(timeout);
            
        }
    }, [domainListResponse, customerId, organizationId, domainId, domainAllValue, searchParams, pathname, setSearchParams, domainSearch, fetchDomainDetails, scanId, dispatch]);

    useEffect(()=>{
        if(customerDetailResponse !== null && customersListResponse !== null) {
            let obj = {
                id: customerId,
                name: customerDetailResponse?.name,
                value: customerId,
                logo: customerDetailResponse?.logo,
                label: customerDetailResponse?.name
            }
            setSelectedCustomer(obj.value)
            let isAvailableInCustomerList = customersList.some((data) => data.id === customerId)
            if(!isAvailableInCustomerList) {
                setCustomersList([...customersList, obj]);
            }
            dispatch(resetCustomerDetailResponse())            
        }
    },[customerDetailResponse, customerId, customersList, customersListResponse, dispatch])

    useEffect(()=>{
        if(organizationDetailResponse !== null && organizationListResponse !== null) {
            let obj = {
                id: organizationId,
                name: organizationDetailResponse?.name,
                value: organizationId,
                logo: organizationDetailResponse?.logo,
                label: organizationDetailResponse?.name,
            }
            setSelectedOrganization(obj.value)
            let isAvailableInOrgsList = organizationList.some((data) => data.id === organizationId)
            if(!isAvailableInOrgsList) {
                setOrganizationList([...organizationList, obj])
            }
            dispatch(resetOrganizationDetail())            
        }
    },[organizationDetailResponse, organizationListResponse, organizationId, organizationList, dispatch])

    useEffect(()=>{
        if(domainDetailResponse !== null && domainList.length > 0) {
            let obj = {
                id: domainDetailResponse?.domain_id,
                name: domainDetailResponse?.domain,
                value: domainDetailResponse?.domain_id,
                logo: domainDetailResponse?.logo,
                label: domainDetailResponse?.domain,
                domain: domainDetailResponse?.domain,
                lastScanDetails: domainDetailResponse?.last_scan_detail
            }
            setSelectedDomain(obj.value);
            let isAvailableInDomainList = domainList.some((data) => data.id === domainDetailResponse?.domain_id)
            if(!isAvailableInDomainList) {
                setDomainList([...domainList, obj])
            }
            dispatch(resetDomainDetails())
        }
    },[domainDetailResponse, domainListResponse, domainId, domainList, dispatch]);

    useEffect(()=>{
        if(scanHistoryResponse != null) {
            setScanHistoryLoading(false)
            if(scanHistoryResponse?.results.length > 0) {                
                if(scanHistoryResponse?.meta?.total_pages > scanHistoryCurrentPage) {
                    let dates = scanHistoryResponse?.results.map((item) => {
                        const [datePart] = item.created_at.split(" ");
                        const [year, month, day] = datePart.split("-").map(Number);
                        return new Date(year, month - 1, day); // Safe local date
                    });
                    setAvailabelDates(prev => [...prev, ...dates]);

                    const results = scanHistoryResponse?.results || [];
                    setAllScanHistoryResults(prev => [...prev, ...results]);

                    setScanHistoryCurrentPage(prevPage => prevPage + 1)
                } else {                    
                    let dates = scanHistoryResponse?.results.map((item) => {
                        const [datePart] = item.created_at.split(" ");
                        const [year, month, day] = datePart.split("-").map(Number);
                        return new Date(year, month - 1, day); // Safe local date
                    });
                    setAvailabelDates(prev => [...prev, ...dates])  
                    
                    setScanHistoryList({
                        meta: scanHistoryResponse?.meta,
                        results: [...allScanHistoryResults, ...scanHistoryResponse?.results]
                    });

                    let scanHistoryResults = [...allScanHistoryResults, ...scanHistoryResponse?.results]
                    let index = scanHistoryResults?.findIndex(data => data.scan_id === scanId);
                    if(index > -1 ) {                     
                        setSelectedDate(scanHistoryResults[index]?.created_at);
                        setScanType(scanHistoryResults[index]?.scan_type);
                        const updatedParams = new URLSearchParams(searchParams.toString());
                        updatedParams.set('scanId', scanHistoryResults[index]?.scan_id);
                        setSearchParams(updatedParams);
                    } else {                     
                        setSelectedDate(scanHistoryResults[0]?.created_at);
                        setScanType(scanHistoryResults[0]?.scan_type);
                        searchParams.set('scanId', scanHistoryResults[0]?.scan_id);
                        setSearchParams(searchParams);
                    }
                }                                
            } else {
                setScanHistoryList(null)
                setAvailabelDates([])
                searchParams.set('scanId', "null");
                setSearchParams(searchParams);
                setSelectedDate("");
                setScanType(null);
                setScanHistoryCurrentPage(1);
                setScanHistoryAllDates([]);
            }
            dispatch(resetScanHistoryList());
        }
    },[scanHistoryResponse, dispatch, searchParams, setSearchParams, scanId, scanHistoryCurrentPage, scanHistoryAllDates, scanHistoryList, allScanHistoryResults])

    useEffect(() => {
        setAllScanHistoryResults([]);
        setScanHistoryCurrentPage(1);
        setAvailabelDates([]);
    }, [domainId]);

    const fetchPortfolioCustomersList = useCallback(()=>{
        setPortfolioCustomerLoading(true)
        let url = `&page=1&page_size=10`
        dispatch(getPorfolioCustomersList(url))
    },[dispatch])

    useEffect(()=>{        
        const baseUrl = `&page=${portfolioCustomerListCurrentPage}&page_size=10`;
        const queryParams = debouncedPortfolioCustomerSearch ? `&query=${debouncedPortfolioCustomerSearch}` : "";
        const url = `${baseUrl}${queryParams}`
        dispatch(getPorfolioCustomersList(url))
    },[dispatch, debouncedPortfolioCustomerSearch, portfolioCustomerListCurrentPage])

    useEffect(()=>{
        if(routeContext.isPortfolioPage && getloggedInUserType() === "internal") {
            fetchPortfolioCustomersList()
        }        
    },[routeContext.isPortfolioPage, fetchPortfolioCustomersList])

    useEffect(()=>{
        if(portfolioCustomersListResponse !== null) {
            setPortfolioCustomerLoading(false)
            setPortfolioCustomerSearchLoading(false)
            setPortfolioCustomerListPageLoading(false)
            const list = Array.isArray(portfolioCustomersListResponse?.results)
            ? portfolioCustomersListResponse?.results.map((data) => ({
                  id: data.customer_id,
                  name: data.name,
                  value: data.customer_id,
                  logo: data.logo,
                  label: data.name,
              }))
            : [];
            let finalList = [...list]
            setPortfolioCustomersList((prevList) => {
                const uniqueList = [...prevList, ...finalList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setPortfolioCustomerListTotalPage(portfolioCustomersListResponse?.meta?.total_pages)
            if(portfolioSelectedCustomer === "" && list.length > 0) {
                setPortfolioSelectedCustomer(list[0].value)
                dispatch(portfolioCustomerSelectedValue(list[0].value))
            }                  
        } else {
            setPortfolioCustomerSearchLoading(false)
            setPortfolioCustomersList([])
        }
    },[portfolioCustomersListResponse, dispatch, portfolioSelectedCustomer])

    useEffect(() => {
        // Parse `splitLocation` only when `pathname` changes
        const splitLocation = pathname.split("/");
        if (splitLocation.length === 5) {            
            const heading = splitLocation[4].split("-");            
            if(heading.length === 2) {
                if(heading[0] === "ip" && heading[1] === "address") {
                    setPageHeading("IP Address");
                } if(heading[0] === "ip" && heading[1] === "address") {
                    setPageHeading("IP Addresses");
                } else if(heading[0] === "sub" && heading[1] === "domain") {
                    setPageHeading("Subdomains");
                } else if(heading[0] === "dns" && heading[1] === "records") {
                    setPageHeading("DNS Records");
                } else if(heading[0] === "ssl" && heading[1] === "records") {
                    setPageHeading("SSL Records");
                } else if(heading[0] === "js" && heading[1] === "secrets") {
                    setPageHeading("JS Secrets");
                } else if(heading[0] === "ssl" && heading[1] === "vulnerabilities") {
                    setPageHeading("SSL Vulnerabilities");
                } else if(heading[0] === "sslandtls" && heading[1] === "security") {
                    setPageHeading("SSL/TLS Security");
                } else {
                    const str = `${heading[0]} ${heading[1]}`;
                    setPageHeading(str);
                }
            } else {
                if(heading[0] === "cves") {
                    setPageHeading("CVEs");
                } else if (heading[0] === "cnvds") {
                    setPageHeading("CNVDs");
                } else if(heading[0] === "ransomeware" && heading[1] === "group" && (heading[2] === "intel" || heading[2] === "leaks")){
                    setPageHeading("Ransomware Group Leaks");
                } else if(heading[0] === "sub" && heading[1] === "domain" && heading[2] === "takeover") {
                    setPageHeading("Subdomain Takeover");
                } else {
                    setPageHeading(heading[0]);
                }                
            }
        } else {
            if(splitLocation[splitLocation.length - 1] === "corporate-email-risk") {
                setPageHeading("Corporate Email Risk")
            } else if(splitLocation[splitLocation.length - 1] === "exposure-management") {
                setPageHeading("Select the options to download the report")
            } else if(splitLocation[splitLocation.length - 1] === "dashboard-overview") {
                setPageHeading("Dashboard Overview")
            } else if(splitLocation[splitLocation.length - 1] === "vendor-risk-profile") {
                setPageHeading("Vendor Risk Profile")
            } else {
                setPageHeading(splitLocation[splitLocation.length - 1])
            }            
        }
        if(splitLocation[2] === "reports" || splitLocation[2] === "portfolio" || (splitLocation[2] === "third-party" && splitLocation[3] === "dashboard-overview")) {
            setHideSwitchShow(true)
        } else {
            setHideSwitchShow(false)
        }
    }, [pathname]);

    return (
        <>
            <div className="page-header-container px-4 py-3 d-flex align-items-center justify-content-between">
                <div className="header-left d-flex align-items-center gap-3">
                    <h1>{pageHeading}</h1>
                </div>
                {
                    getloggedInUserType() === "internal" && pathname.split("/")[2] === "third-party" && pathname.split("/")[3] === "dashboard-overview" &&
                    <div className="d-flex switch-container w-25">
                        <div className="switch-organization w-100">
                            <p>Switch Customer</p>
                            {
                                customerLoading || organizationLoading || domainLoading ?
                                    <SkeletonLoader type={"line"} count={1} currentPage="header" />
                                :
                                <DropDown
                                    options={customersList}
                                    placeHolder='Please select customer'
                                    onChange={(e) => handleSelectCustomer(e)}
                                    isSearchable = {true}
                                    dropDownType = {'scanInfo'}
                                    imageType={"customer"}
                                    defaultSelectedValue={selectedCustomer}
                                    searchType={"server"}
                                    updateSearchValue={(data)=>{
                                        setCustomersList([])
                                        setCustomerSearchLoading(true)
                                        setCustomerSearch(data)
                                        setCustomerListCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage));
                                    }}
                                    isSearchLoading={customerSearchLoading}
                                    onScrollEnd = {()=>{
                                        if(!customerListPageLoading && (customerListTotalPage > customerListCurrentPage)) {
                                            setCustomerListPageLoading(true)
                                            setCustomerListCurrentPage((prevPage) => prevPage + 1)
                                        }
                                    }}
                                    pageLoading={customerListPageLoading}
                                />
                            }
                        </div>
                    </div>
                }
                {pathname.split("/")[2] !== "reports" && pathname.split("/")[2] !== "portfolio"  && pathname.split("/")[3] !== "dashboard-overview" && <div className="scan-info-header-right">
                    <button className="download-report-button d-flex align-items-center" onClick={()=>setShowAddOrgSidePanel(true)}>
                        <span>{downloadReportIcon()}</span>
                        Download Report
                    </button>
                </div>}
            </div>
            {!hideSwitchShow && <div className="page-header-container px-4 py-3">
                <div className="d-flex gap-3 justify-content-between align-items-center">
                    <div className="d-flex switch-container">
                        {   getloggedInUserType() === "internal" && <>
                                <div className="switch-organization">
                                    <p>Switch Customer</p>
                                    {
                                        customerLoading || organizationLoading || domainLoading ?
                                            <SkeletonLoader type={"line"} count={1} currentPage="header" />
                                        :
                                        <DropDown
                                            options={customersList}
                                            placeHolder='Please select customer'
                                            onChange={(e) => handleSelectCustomer(e)}
                                            isSearchable = {true}
                                            dropDownType = {'scanInfo'}
                                            imageType={"customer"}
                                            defaultSelectedValue={selectedCustomer}
                                            searchType={"server"}
                                            updateSearchValue={(data)=>{
                                                setCustomersList([])
                                                setCustomerSearchLoading(true)
                                                setCustomerSearch(data)
                                                setCustomerListCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage));
                                            }}
                                            isSearchLoading={customerSearchLoading}
                                            onScrollEnd = {()=>{
                                                if(!customerListPageLoading && (customerListTotalPage > customerListCurrentPage)) {
                                                    setCustomerListPageLoading(true)
                                                    setCustomerListCurrentPage((prevPage) => prevPage + 1)
                                                }
                                            }}
                                            pageLoading={customerListPageLoading}
                                        />
                                    }                                    
                                </div>
                                <div className="border-between"></div>
                            </>
                        }
                        <div className="switch-organization">
                            <p>Switch Organization</p>
                            {
                                customerLoading || organizationLoading || domainLoading  ?
                                    <SkeletonLoader type={"line"} count={1} currentPage="header" />
                                :
                                <DropDown
                                    options={organizationList}
                                    placeHolder='Please select Organization'
                                    onChange={(e) => handleSelectOrganization(e)}
                                    isSearchable = {true}
                                    dropDownType = {'scanInfo'}
                                    imageType={"organization"}
                                    defaultSelectedValue={selectedOrganization}
                                    searchType={"server"}
                                    updateSearchValue={(data)=>{
                                        setOrganizationList([])
                                        setOrganizationSearchLoading(true)
                                        setOrganizationSearch(data)
                                        setOrganizationListCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage));
                                    }}
                                    isSearchLoading={organizationSearchLoading}
                                    onScrollEnd = {()=>{
                                        if(!organizationListPageLoading && (organizationListTotalPage > organizationListCurrentPage)) {
                                            setOrganizationListPageLoading(true)
                                            setOrganizationListCurrentPage((prevPage) => prevPage + 1)
                                        }
                                    }}
                                    pageLoading={organizationListPageLoading}
                                />
                            }                            
                        </div>
                        <div className="border-between"></div>
                        <div className="switch-organization">
                            <p>Switch Domain</p>
                            {
                                customerLoading || organizationLoading || domainLoading  ?
                                    <SkeletonLoader type={"line"} count={1} currentPage="header" />
                                :
                                <DropDown
                                    options={domainList}
                                    placeHolder='Please select Domain'
                                    onChange={(e) => handleSelectDomain(e)}
                                    isSearchable = {true}
                                    dropDownType = {'scanInfo'}
                                    imageType={"domain"}
                                    defaultSelectedValue={selectedDomain}
                                    searchType={"server"}
                                    updateSearchValue={(data)=>{
                                        setDomainList([])
                                        setDomainSearch(data)
                                        setDomainSearchLoading(true)
                                        setDomainListCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage));
                                    }}
                                    isSearchLoading={domainSearchLoading}
                                    onScrollEnd = {()=>{
                                        if(!domainListPageLoading && (domainListTotalPage > domainListCurrentPage)) {
                                            setDomainListPageLoading(true)
                                            setDomainListCurrentPage((prevPage) => prevPage + 1)
                                        }
                                    }}
                                    pageLoading={domainListPageLoading}
                                />
                            }                            
                        </div>
                        <div className="border-between"></div>
                    </div>
                    <div className="scan-info-date-container d-flex">
                            {
                                scanHistoryLoading ?
                                    <SkeletonLoader type={"line"} count={1} currentPage="header" />
                                :
                                    <div className="scan-info-details">
                                        <p>Scan Type : {domainId.toLowerCase() !== "all" ? <span className={`scan-type ${scanType}`}>{scanType !== null ? scanType : "-"}</span> : "-"}</p>
                                    </div>
                            }
                            <div className="border-between"></div>
                            <div className="scan-info-datepicker">
                            {
                                scanHistoryLoading ?
                                    <div className="date-picker-loader">
                                        <SkeletonLoader type={"line"} count={1} currentPage="header" />
                                    </div>
                                :
                                <DatePicker
                                    showIcon
                                    selected={selectedDate}
                                    onChange={changeScannedDate}
                                    filterDate={isAvailableDate} // Enable only available dates
                                    dayClassName={highlightAvailableDates} // Highlight available dates
                                    placeholderText="Select an date"
                                    icon={CalenderIcon()}
                                    dateFormat="MMM dd, yyyy"
                                    customInput={<CustomDateInput />}
                                    maxDate={new Date()}
                                    className="custom-width-datepicker"
                                    disabled={domainId.toLowerCase() === "all"}
                                >
                                    <div className="additional-content">
                                        <div className="selected-date"><span></span>Selected Date</div>
                                        <div className="scanned-date"><span></span>Scanned Date</div>
                                    </div>
                                </DatePicker>
                            }
                        </div>
                    </div>
                </div> 
            </div>}
            {(pathname.split("/")[2] === "portfolio" && getloggedInUserType() === "internal") && <div className="page-header-container px-4 py-3">
                <div className="d-flex gap-3 justify-content-between align-items-center">
                    <div className="d-flex switch-container">
                        <div className="switch-organization">
                            <p>Switch Customer</p>
                            {
                                portfolioCustomerLoading ?
                                    <SkeletonLoader type={"line"} count={1} currentPage="header" />
                                :
                                <DropDown
                                    options={portfolioCustomersList}
                                    placeHolder='Please select customer'
                                    onChange={(data) => {
                                        setPortfolioSelectedCustomer(data.value)
                                        dispatch(portfolioCustomerSelectedValue(data.value))
                                    }}
                                    isSearchable = {true}
                                    dropDownType = {'scanInfo'}
                                    imageType={"customer"}
                                    defaultSelectedValue={portfolioSelectedCustomer}
                                    searchType={"server"}
                                    updateSearchValue={(data)=>{
                                        setPortfolioCustomersList([])
                                        setPortfolioCustomerSearchLoading(true)
                                        setPortfolioCustomerSearchValue(data)
                                        setPortfolioCustomerListCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage));
                                    }}
                                    isSearchLoading={portfolioCustomerSearchLoading}
                                    onScrollEnd = {()=>{
                                        if(!portfolioCustomerListPageLoading && (portfolioCustomerListTotalPage > portfolioCustomerListCurrentPage)) {
                                            setPortfolioCustomerListPageLoading(true)
                                            setPortfolioCustomerListCurrentPage((prevPage) => prevPage + 1)
                                        }
                                    }}
                                    pageLoading={portfolioCustomerListPageLoading}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>}
            <SideModal showSidePanel={showAddOrgSidePanel} hideSidePanel={closeAddOrgSidePanel}>
                {showAddOrgSidePanel && <DownloadReport currentPageType={"header"} organizationListOption={organizationList} closeDownloadReport={closeAddOrgSidePanel}/>}
            </SideModal>
        </>
    )
}

export default Header;